"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageToName = exports.Language = void 0;
var Language;
(function (Language) {
    // These values have to be lower case to tie in with Commerce Tools
    Language["en"] = "en";
    Language["is"] = "is";
})(Language || (exports.Language = Language = {}));
var languageToName = function (code) {
    switch (code) {
        case Language.en:
            return "English";
        case Language.is:
            return "Icelandic";
    }
};
exports.languageToName = languageToName;
//# sourceMappingURL=Language.js.map